import { Component, Input, EventEmitter, Output } from '@angular/core';
import { User } from '../manage-access.model';

@Component({
  selector: 'cigna-user-summary-item',
  templateUrl: './user-summary-item.component.html',
  styleUrls: ['./user-summary-item.component.scss'],
})
export class UserSummaryItemComponent {
  @Input() user: User;
  @Input() mode = 'view';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() allowRemove = true;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() allowView = true;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() showJobRole = true;
  @Output() viewAccessForUser = new EventEmitter();
  @Output() removeUserFromEdit = new EventEmitter();
}
